export const GET_DOC = '{master-template} GET_DOC';
export const CREATE_EDITED_DRAFT = '{master-template} CREATE_EDITED_DRAFT';
export const GET_DIFF_SUMMARY = '{master-template} GET_DIFF_SUMMARY';
export const INITIATE_EDIT_WITH_TYPE = '{master-template} INITIATE_EDIT_WITH_TYPE';
export const POPULATE_EDIT_DIALOG_DATA = '{master-template} POPULATE_EDIT_DIALOG_DATA';
export const CANCEL_EDIT = '{master-template} CANCEL_EDIT';
export const CLICK_FINALISE = '{master-template} CLICK_FINALISE_BUTTON';
export const FINALISE = '{master-template} FINALISE_BUTTON';
export const OPEN_FINALISE_DIALOG = '{master-template} OPEN_FINALISE_DIALOG';
export const CLOSE_FINALISE_DIALOG = '{master-template} CLOSE_FINALISE_DIALOG';
export const SEND_UPDATES = '{master-template} SEND_UPDATES';
export const DISCARD_DRAFT = '{master-template} DISCARD_DRAFT';
export const GET_ASSOCIATED_TEMPLATES = '{master-template} GET_ASSOCIATED_TEMPLATES';
export const TOGGLE_ASSOCIATED_TEMPLATES = '{master-template} TOGGLE_ASSOCIATED_TEMPLATES';
export const GET_AFFECTED_BUYERS = '{master-template} GET_AFFECTED_BUYERS';

export const SAVE_EDITS = '{edit-dialog} SAVE_EDITS';
export const TEXT_FIELD_CHANGE = '{edit-dialog} TEXT_FIELD_CHANGE';
export const ATTACH_INS_FILE = '{edit-dialog} ATTACH_INS_FILE';
export const REMOVE_INSURANCE_FILE = '{edit-dialog} REMOVE_INSURANCE_FILE';


export const apply = {
  INIT: `{apply-master-to-template} INIT`,
  GET_TEMPLATES: '{apply-master-to-template} GET_TEMPLATES',
  SELECT_UNSELECT_TEMPLATE: '{apply-master-to-template} SELECT_UNSELECT_TEMPLATE',
  APPLY_TO_TEMPLATES: '{apply-master-to-template} APPLY_TO_TEMPLATES_TO_TEMPLATE_DRAFTS',
  CLICK_OK_SUCCESS: '{apply-master-to-template} CLICK_OK_SUCCESS',
  CHECK_SAME_AS: '{apply-master-to-template} CHECK_SAME_AS',
  SELECT_MASTER: '{apply-master-to-template} SELECT_MASTER',
  GET_MASTERS: '{apply-master-to-template} GET_MASTERS',
  CLEAR_STORE: '{apply-master-to-template} CLEAR_STORE',
  CHECK_HONOR_PRELOAD: '{apply-master-to-template} CHECK_HONOR_PRELOAD',
};



// WEBPACK FOOTER //
// ./src/app/components/contracting/master-template/__storeFiles__/constants.js